import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { useCreateBillingEntity } from 'src/features/billing/api/useCreateBillingEntity';
import BillingEntityFormModal from 'src/features/billing/components/forms/BillingEntityFormModal';
import { billingMessages } from 'src/features/billing/utils/messages';
import { LIST_BILLING_ENTITIES_RESOURCE } from 'src/features/billing/api/useListBillingEntities';
import { BillingEntity } from 'src/features/billing/utils/types';
import { toast } from 'src/hooks/useToast';

interface CreateBillingEntityFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedBillingEntity?: BillingEntity;
    children?: React.ReactNode;
}

function CreateBillingEntityFormModal<TData>({ className, semantics }: CreateBillingEntityFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutateAsync, isPending } = useCreateBillingEntity({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_BILLING_ENTITIES_RESOURCE] });
            toast({
                title: formatMessage(billingMessages.createBillingEntitySuccess),
                description: formatMessage(billingMessages.createBillingEntitySuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <BillingEntityFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutateAsync({ data: values }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(billingMessages.addBillingEntitySubtitle)}
        />
    );
}

export default CreateBillingEntityFormModal;
